import getApplicationConfig from '../common/config'

export const loadFavicon = () => {
  const config = getApplicationConfig(window.location.href)

  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const useDarkIcon = !prefersDark && config.hasDarkFavicon
  const faviconFile = useDarkIcon ? 'favicon-dark.ico' : 'favicon.ico'

  const oldFavicon = document.querySelector("link[rel~='icon']")
  const link = document.createElement('link')
  const faviconUrl = `${window.location.origin}/${config.theme}/${faviconFile}`

  link.rel = 'icon'
  link.href = faviconUrl

  if (oldFavicon) {
    document.head.removeChild(oldFavicon)
  }
  document.head.appendChild(link)

  if (config.faviconTitle) {
    document.title = config.faviconTitle
  }
}
